import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "dialog__title-section" };
const _hoisted_2 = { class: "dialog-title-text body2-text" };
import { computed, ref, watch, nextTick, } from 'vue';
import vuexStore from '@/vuex-store';
import { i18n } from '@/locales';
import { targetType } from '@/constants/operationSetting/option';
import { tabList } from '@/constants/operationSetting/operationSettingSettingDialog';
import { createOperationSettingFormData, } from '@/form/form-data/operationSettingSettingDialog';
import DialogHeader from '@/components/Dialog/DialogHeader.vue';
import DialogFooter from '@/components/Dialog/DialogFooter.vue';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { operationSettingActionType } from '@/vuex-store/operation-setting/actions';
import ApplyConfigSurcharge from './ApplyConfigSurcharge.vue';
import IrregularSurcharge from './IrregularSurcharge.vue';
import DeliveryStatus from './DeliveryStatus.vue';
const dialogLc = 'views.operation_setting_dialog.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // 운행설정 변경 다이얼로그 (허브, 상점 공통)
        const getComp = (n) => ({
            ApplyConfigSurcharge,
            IrregularSurcharge,
            DeliveryStatus,
        }[n]);
        const firstTab = tabList[0];
        const formData = ref(createOperationSettingFormData());
        const formRef = ref();
        const isDialogOpen = ref(false);
        const component = ref(firstTab.componentName);
        const selectedType = ref(firstTab.value);
        // 추가할증의 할증금액은 submit 이후에 유효성 검사가 진행됩니다.
        const isSubmitted = ref(false);
        const setFormData = (key, value) => {
            // @ts-ignore
            formData.value[key] = value;
        };
        const resetFormData = () => {
            formData.value = {};
        };
        const title = computed(() => {
            const currentTarget = vuexStore.state.operationSetting.selectedTarget;
            return currentTarget === targetType.HUB
                ? i18n.t(`${dialogLc}hub_title`)
                : i18n.t(`${dialogLc}store_title`);
        });
        const dialogInfoText = computed(() => {
            const currentTarget = vuexStore.state.operationSetting.selectedTarget;
            return currentTarget === targetType.HUB
                ? i18n.t(`${dialogLc}hub_dialog_info_text`)
                : i18n.t(`${dialogLc}store_dialog_info_text`);
        });
        const handleClickTab = (tab) => {
            component.value = getComp(tab.componentName);
            selectedType.value = tab.value;
            resetFormData();
        };
        const resetTabComponent = () => {
            component.value = getComp(firstTab.componentName);
            selectedType.value = firstTab.value;
        };
        const handleClickCancel = () => {
            vuexStore.dispatch(operationSettingActionType.setIsOpenDialog, false);
        };
        const setIsSubmitted = (value) => {
            isSubmitted.value = value;
        };
        const _submit = async () => {
            try {
                await vuexStore.dispatch(operationSettingActionType.postOperationSetting, {
                    selectedType: selectedType.value,
                    formData: formData.value,
                });
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t(`${dialogLc}success`),
                });
            }
            catch (error) {
                console.log('operationSetting/SettingDialog/_submit', error);
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
            }
        };
        /**
         * 전송 클릭 핸들러
         */
        const handleClickSubmit = () => {
            setIsSubmitted(true);
            nextTick(async () => {
                const isValid = await formRef.value.validate();
                if (!isValid.valid) {
                    return;
                }
                _submit();
            });
        };
        watch(() => vuexStore.state.operationSetting.isOpen, (isOpen) => {
            if (!isOpen) {
                return;
            }
            setIsSubmitted(false);
        });
        watch(() => vuexStore.state.operationSetting.isOpen, (isOpen) => {
            isDialogOpen.value = isOpen;
            resetTabComponent();
        });
        return (_ctx, _cache) => {
            const _component_v_tab = _resolveComponent("v-tab");
            const _component_v_tabs = _resolveComponent("v-tabs");
            const _component_v_window_item = _resolveComponent("v-window-item");
            const _component_v_window = _resolveComponent("v-window");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (isDialogOpen.value)
                ? (_openBlock(), _createBlock(_component_v_dialog, {
                    key: 0,
                    modelValue: isDialogOpen.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isDialogOpen).value = $event)),
                    width: "620",
                    "content-class": "dialog",
                    "onClick:outside": handleClickCancel,
                    onKeydown: _withKeys(handleClickCancel, ["esc"])
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_card, null, {
                            default: _withCtx(() => [
                                _createVNode(DialogHeader, {
                                    title: title.value,
                                    "on-cancel": handleClickCancel
                                }, null, 8 /* PROPS */, ["title"]),
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("span", _hoisted_2, _toDisplayString(dialogInfoText.value), 1 /* TEXT */),
                                    _createVNode(_component_v_tabs, {
                                        "background-color": "transparent",
                                        color: "primary"
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabList), (tab, key) => {
                                                return (_openBlock(), _createBlock(_component_v_tab, {
                                                    key: key,
                                                    onClick: ($event) => (handleClickTab(tab))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(tab.text), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createVNode(_component_v_form, {
                                    ref_key: "formRef",
                                    ref: formRef,
                                    class: "main-content dialog__content-section"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_window, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_window_item, null, {
                                                    default: _withCtx(() => [
                                                        _createCommentVNode(" 카드 내부 "),
                                                        (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), {
                                                            "is-submitted": isSubmitted.value,
                                                            "set-is-submitted": setIsSubmitted,
                                                            onSetFormData: setFormData
                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, ["is-submitted"]))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 512 /* NEED_PATCH */),
                                _createVNode(_component_v_divider),
                                _createVNode(DialogFooter, {
                                    cancel: "",
                                    change: "",
                                    "on-cancel": handleClickCancel,
                                    "on-change": handleClickSubmit
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"]))
                : _createCommentVNode("v-if", true);
        };
    }
});
